var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":_vm.title,"text":_vm.text,"notification-buttons":[
                      {
                        title: _vm.buttonTitle,
                        variant: 'primary',
                        size: 'small',
                        action: _vm.updatePayment,
                      } ],"header-path":_vm.image,"show-header":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }